import React from "react";
import { NavLink } from "react-router-dom";
import EyeNoData from "../../../components/Nav & Header/Eye";
function NoData() {
  return (
    <div>
      <div className="mb-[200px] md:gap-y-[0px] lg:gap-y-[40px] px-[15px] md:px-0 flex flex-col items-center justify-center w-full">
        <div className="nodatazoom">
          <EyeNoData />
        </div>
        <div className="space-y-6 max-w-[700px] text-center text-tertiary ">
          <p className="text-[14px] sm:text-[16px] capitalize font-SoraL">
            No novel with that name. <br /> propably because this is a new
            website. contribute by creating new novels!
          </p>
          <div className="flex justify-center items-center scale-90">
            <div
              className="w-0 h-0 
   border-l-[10px] border-l-transparent
   border-t-[10px] border-t-primary
   border-r-[10px] border-r-transparent
   "
            ></div>
          </div>
          {/* <button > */}
          <div className="w-fit m-auto cursor-pointer flex justify-center items-center">
            <NavLink to="/create">
              <div className="Purple-btn-effect flex justify-center items-center font-SoraR hover:bg-primary/90 duration-500 ease-in-out w-[163px] h-[52px] bg-primary relative z-10 text-tertiary">
                Create Now
              </div>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoData;
